import { render, staticRenderFns } from "./AddTransferCampaign.vue?vue&type=template&id=2e3b4aeb&scoped=true&"
import script from "./AddTransferCampaign.vue?vue&type=script&lang=js&"
export * from "./AddTransferCampaign.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e3b4aeb",
  null
  
)

export default component.exports